import React from 'react';

/**
 * setta la x, y di un array di elementi (child)
 * in maniera che questi vengano messi uno sotto l'altro
 * per fare questo tutti i child devo avere la prop "height"
 * Se questa non c'e' fa un tentativo chiamando la static "CalcHeight"
 */
function LayoutCollection({
	x = 0,
	y = 0,
	height,
	children,
	initY = 0,
}: LayoutCollectionProps): any {

	let count = 0

	return React.Children.map(children, (child, index) => {
		if (!React.isValidElement(child)) return
		if (child.props.height == false || child.props.height == 0) return null

		// scostamento verticale dell'oggetto da renderizzare
		const offsetY = child.props.y ?? 0
		// la posizione Y del prossimo CHILD
		const nextY = y + count + offsetY
		// l'height del prossimo CHILD
		const calcHeight = getHeight(child)

		count += offsetY + calcHeight

		// se è fuori dall'area visibile allora non renderizzare nulla
		if (height != null && !child.props.fixed){
			if ( nextY > height) return null
			if ((nextY + calcHeight) < initY) return null
		}
		
		// creo il clone del componente e setto le proprietà
		const clone = React.cloneElement<any>(child, {
			x: child.props.x ?? x,
			y: child.props.fixed ? 0 : nextY
		})
		
		return clone
	});
}

export default LayoutCollection

LayoutCollection.CalcHeight = ({ children }) => {
	return children.reduce((sum: number, child: any) => sum + getHeight(child), 0)
}

function getHeight(child) {
	return child?.props?.height ??
		(child?.type?.CalcHeight ? child?.type?.CalcHeight(child.props) : 0)
}

type LayoutCollectionProps = {
	x?: number,
	y?: number,
	initY?: number,
	height?: number,
	children?: React.ReactNode,
}